export function formatDate(isoDate) {
  if (!isoDate) return "";
  const [year, month, day] = isoDate.split("-");
  return `${Number(month)}/${Number(day)}/${year}`;
}

export function parseDate(dateString) {
  if (!dateString) return "";
  // Check if dateString is already in ISO format: "YYYY-MM-DD"
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }
  // Otherwise, parse and reformat it (assuming "MM/DD/YYYY" format)
  const [month, day, year] = dateString.split("/");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function formatTime(timeString) {
  if (!timeString) return "";
  // Assume timeString is in "HH:MM:SS" format.
  const [hourStr, minuteStr] = timeString.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr; // Already a two-digit string
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  if (hour === 0) hour = 12;
  return `${hour}:${minute} ${period}`;
}

export function parseTime(formattedTime) {
  if (!formattedTime) return "";
  if (/^\d{2}:\d{2}$/.test(formattedTime)) {
    return formattedTime + ":00";
  }
  // Expect formattedTime in "h:mm AM/PM" format.
  const parts = formattedTime.split(" ");
  if (parts.length !== 2) {
    console.error("parseTime: Invalid time format:", formattedTime);
    return "";
  }
  const [timePart, period] = parts;
  const [hourStr, minuteStr] = timePart.split(":");
  let hour = parseInt(hourStr, 10);
  if (period.toUpperCase() === "PM" && hour < 12) {
    hour += 12;
  } else if (period.toUpperCase() === "AM" && hour === 12) {
    hour = 0;
  }
  // Return in "HH:MM:00" format
  return `${hour.toString().padStart(2, "0")}:${minuteStr.padStart(2, "0")}:00`;
}